import type { FC } from "react";
import type { IChatAttachmentBrief, ICitation } from "@/api";
import { handleAttachmentAction } from "@/components/shared/attachment-action";
import { AttachmentPillRow } from "@/components/shared/AttachmentPillRow";
import { useAttachmentExportModals } from "@/hooks/useAttachmentExportModals";
import { useDocumentViewer } from "../contexts/useDocumentViewer";

interface ReferencesData {
    citations?: ICitation[];
    autoAttachments?: IChatAttachmentBrief[];
}

/**
 * Renders citation + auto-attachment pills on assistant messages via the
 * shared `AttachmentPillRow`. Owns action dispatch and the export-modal
 * lifecycle; the row primitive is purely presentational.
 */
export const ReferencesDataPart: FC<{ data: ReferencesData }> = ({ data }) => {
    const citations = data.citations ?? [];
    const attachments = data.autoAttachments ?? [];
    const { openDocument } = useDocumentViewer();
    const { triggerScopeExport, triggerComparisonExport, exportModalsElement } =
        useAttachmentExportModals();

    if (citations.length === 0 && attachments.length === 0) return null;

    return (
        <>
            <div className="mt-2">
                <AttachmentPillRow
                    citations={citations}
                    attachments={attachments}
                    onAction={(ref, action) =>
                        handleAttachmentAction(ref, action, {
                            openDocument,
                            citationFallback: citations,
                            onExportScope: triggerScopeExport,
                            onExportComparison: triggerComparisonExport,
                        })
                    }
                />
            </div>
            {exportModalsElement}
        </>
    );
};
